/**
 * Best total score, persisted across sessions.
 *
 * Storage is best-effort on purpose: private-mode browsers throw on write, and a
 * transient score must never cost the player their run. Every access is guarded.
 */
const KEY = 'roll-ball-maze:best';

export function loadBest(): number {
  try {
    const raw = window.localStorage.getItem(KEY);
    const value = raw == null ? 0 : Number.parseInt(raw, 10);
    return Number.isFinite(value) && value > 0 ? value : 0;
  } catch {
    return 0;
  }
}

export function saveBest(value: number): void {
  try {
    window.localStorage.setItem(KEY, String(Math.max(0, Math.round(value))));
  } catch {
    /* private / disabled storage — the best score simply won't persist */
  }
}
